<script setup>
import { computed, ref, watch } from 'vue'
import AppInput from '#/general/AppInput.vue'
import Popper from 'vue3-popper'
import { useVModel } from '@vueuse/core'
import PhoneNumber from 'awesome-phonenumber'
import CountryFlag from 'vue-country-flag-next'
const props = defineProps(['phoneNumber'])
const emit = defineEmits(['update:phoneNumber', 'clicked', 'input', 'focus'])
const phoneNumber = useVModel(props, 'phoneNumber', emit)

const countries = [
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH'
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI'
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE'
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT'
  },
  {
    name: 'USA',
    dial_code: '+1',
    code: 'USA'
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT'
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR'
  }
]

const showCountries = ref(false)
const selectedCountry = ref(null)
const number = ref()

const pn = ref(new PhoneNumber(props.phoneNumber ? props.phoneNumber : ''))
const codeFromVal = pn.value.getCountryCode()
if (codeFromVal) {
  const country = countries.find(e => e.dial_code === `+${codeFromVal}`)
  selectedCountry.value = country || countries[0]
  number.value = props.phoneNumber.replace(`${selectedCountry.value.dial_code}`, '')
} else {
  selectedCountry.value = countries[0]
}

const computedValue = computed({
  get () {
    return number.value
  },
  set (val) {
    const validation = new PhoneNumber(`${selectedCountry.value.dial_code + val}`)
    if (validation.g.valid) {
      number.value = validation.g.number.international.replace(`${selectedCountry.value.dial_code}`, '').trim()
    } else {
      number.value = val
    }
  }
})
watch(selectedCountry, v => {
  const validation = new PhoneNumber(`${selectedCountry.value.dial_code + (number.value ? number.value : '')}`)
  if (validation.g.valid) {
    number.value = validation.g.number.international.replace(`${selectedCountry.value.dial_code}`, '').trim()
  } else {
    number.value = validation.g.number.significant
  }
})
watch(computedValue, v => {
  phoneNumber.value = `${selectedCountry.value.dial_code} ${number.value ? number.value : ''}`
})
</script>

<template lang="pug">
app-input.phone-wrapper(:label="selectedCountry" v-model:value="computedValue" v-bind="props" v-click-away="showCountries = false" :disable-label="true")
  template(#prepend)
    popper.popper-item(:show="showCountries" :interactive="true")
      .phone--item(v-if="selectedCountry" @click="showCountries = !showCountries")
        .phone--flag
          country-flag(:country="selectedCountry.code")
        .phone--code {{ selectedCountry.dial_code }}
      template(#content)
        .phone-flag--countries-wrapper
          .phone--item(v-for="country in countries" :key="country.code" @click="selectedCountry = country; showCountries = false")
            .phone--flag
              country-flag(:country="country.code")
            .phone--code {{ country.dial_code }}
</template>

<style lang="sass">
.popper-item
  margin: 0px !important
  display: unset !important
  border: 0px !important
.phone-flag--countries-wrapper
  width: 100%
  display: flex
  flex-direction: column
  border: 1px solid #ececee
  border-radius: 6px
  background: #2F3849
  padding: 3px 6px 3px 3px
  overflow: auto
  max-height: 300px
.menu--container
  width: unset !important
.phone-wrapper
  .phone--item
    cursor: pointer
    padding-right: 5px
    display: flex
    align-items: center
    margin-top: 1px
    .phone--flag
      margin-bottom: 2px
    .phone--code
      margin-left: 4px
      color: #9D9DD4
      font-weight: 500
      font-size: 16px
</style>
